import { render, staticRenderFns } from "./DoaData.vue?vue&type=template&id=5fa02562&scoped=true&"
import script from "./DoaData.vue?vue&type=script&lang=js&"
export * from "./DoaData.vue?vue&type=script&lang=js&"
import style0 from "./DoaData.vue?vue&type=style&index=0&id=5fa02562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa02562",
  null
  
)

export default component.exports